/** Shared light-shell classes — match Dashboard subpage look (do not use on Landing / Dashboard / Login). */
export const shell = {
  card: 'rounded-xl border border-[#E0DCE5] bg-white shadow-sm',
  cardPad: 'rounded-xl border border-[#E0DCE5] bg-white p-4 shadow-sm sm:p-6',
  tableWrap: 'overflow-hidden rounded-xl border border-[#E0DCE5] bg-white shadow-sm',
  thead: 'border-b border-[#E0DCE5] bg-[hsl(285_35%_97%)]',
  th: 'px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#261D30]/80',
  tr: 'border-b border-neutral-100 bg-white transition-colors hover:bg-neutral-50',
  td: 'whitespace-nowrap px-4 py-4 text-sm',
  textPrimary: 'text-[#261D30]',
  textMuted: 'text-[#73677E]',
  required: 'text-red-600',
  errorText: 'mt-1 text-xs text-red-600',
  iconAccent: 'h-4 w-4 shrink-0 text-[hsl(285_45%_45%)]',
  mono: 'font-mono font-medium text-[#261D30]',
  pageHeader: 'mb-4',
  pageActions: 'flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:flex-wrap sm:items-center',
  emptyStateIcon:
    'mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-[hsl(285_35%_97%)] text-[hsl(285_45%_45%)]',
  modalFormStack: 'space-y-4',
  modalFooter: 'flex w-full flex-col-reverse gap-2 sm:flex-row sm:justify-end sm:gap-2',
  statPurple:
    'rounded-3xl border border-transparent bg-gradient-to-br from-[hsl(285_45%_38%)] to-[hsl(285_45%_28%)] p-6 text-white shadow-lg shadow-[hsl(285_45%_30%/0.2)]',
  statOrange:
    'rounded-3xl border border-transparent bg-gradient-to-r from-[#FF8C00] to-[#F25F00] p-6 text-white shadow-lg shadow-[hsl(32_95%_45%/0.25)]',
  statWhite: 'rounded-3xl border border-neutral-200 bg-white p-6 text-neutral-900 shadow-md shadow-neutral-900/5',
  /** Form controls (Shipments, Carriers, modals) */
  label: 'mb-1 block text-xs font-medium text-gray-500',
  input:
    'w-full rounded-lg border border-neutral-200 bg-white px-3 py-2 text-sm text-[#261D30] placeholder:text-neutral-500 focus:border-[hsl(285_45%_45%)] focus:outline-none focus:ring-2 focus:ring-[hsl(285_45%_45%/0.25)]',
  inputError: 'border-red-500 focus:border-red-500 focus:ring-red-500/20',
  inputDisabled: 'bg-neutral-50 text-neutral-500',
  select:
    'h-10 w-full rounded-lg border border-neutral-200 bg-white px-3 text-sm text-[#261D30] focus:border-[hsl(285_45%_45%)] focus:outline-none focus:ring-2 focus:ring-[hsl(285_45%_45%/0.25)]',
  textarea:
    'w-full rounded-lg border border-neutral-200 bg-white px-3 py-2 text-sm text-[#261D30] placeholder:text-neutral-500 focus:border-[hsl(285_45%_45%)] focus:outline-none focus:ring-2 focus:ring-[hsl(285_45%_45%/0.25)]',
  formSection: 'rounded-xl border border-[#E0DCE5] bg-white p-4 sm:p-5',
  formSectionMuted: 'rounded-xl border border-[#E0DCE5] bg-neutral-50/60 p-4 sm:p-5',
  formSectionTitle: 'mb-4 flex items-center gap-2 text-sm font-semibold text-[#261D30]',
  formIntro: 'mb-4 text-sm leading-relaxed text-[#73677E]',
  emptyState: 'flex flex-col items-center justify-center border-t border-[#E0DCE5] px-4 py-14 text-center sm:px-6 sm:py-16',
} as const;

export function shellInput(hasError?: boolean): string {
  return `${shell.input} ${hasError ? shell.inputError : ''}`;
}
